import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import { CompanyList, UsersList, CorporateSettings } from "@/pages";
import React from "react";
import {
  permissionsCompaniesReadonly,
  permissionsUsersReadonly,
  permissionsSettings,
} from "@/utils";

import { userRoutes } from "./userRoutes";
import { companyRoutes } from "./companyRoutes";
import { tenantRoutes } from "./tenantRoutes";
import { locationRoutes } from "./locationRoutes";

const parentPath = "corporate-group";

/**
 * Route definitions for company administration routes.
 * Includes user management, company listing, and document handling for company admins.
 */
export const corporateGroupRoutes: React.ReactElement<any>[] = [
  <Route
    key="corporate-settings"
    path="settings"
    element={
      <ProtectedRoute
        element={(<CorporateSettings />) as React.ReactElement<any>}
        codes={permissionsSettings}
      />
    }
  />,
  <Route
    key="company-users"
    path="company-users"
    element={
      <ProtectedRoute
        element={
          (
            <UsersList userFilter="tenant" parentPath={parentPath} showUnlink />
          ) as React.ReactElement<any>
        }
        codes={permissionsUsersReadonly}
      />
    }
  />,
  // <Route
  //   key="company-users-profile"
  //   path="company-users/:userId/profile"
  //   element={
  //     <ProtectedRoute
  //       element={(<UserProfile />) as React.ReactElement<any>}
  //       codes={permissionsUsersReadonly}
  //     />
  //   }
  // />,
  <Route
    key="tenants-companies"
    path="companies"
    element={
      <ProtectedRoute
        element={
          (
            <CompanyList
              companyFilter="tenant"
              parentPath={parentPath}
              parentChildfilter="all"
            />
          ) as React.ReactElement<any>
        }
        codes={permissionsCompaniesReadonly}
      />
    }
  />,
  // <Route
  //   key="companies-child-companies"
  //   path="companies/:customerId/child-companies"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         (
  //           <SubsidiaryList parentPath={parentPath} />
  //         ) as React.ReactElement<any>
  //       }
  //       codes={permissionsCompaniesReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="tenants-companies-child-companies"
  //   path="tenants/:tenantId/companies/:customerId/child-companies"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         (
  //           <SubsidiaryList parentPath={parentPath} />
  //         ) as React.ReactElement<any>
  //       }
  //       codes={permissionsCompaniesReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents"
  //   path="documents"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         (
  //           <Documents
  //             parentPath={parentPath}
  //             showAdd={false}
  //             showEdit={false}
  //             showDelete={false}
  //           />
  //         ) as React.ReactElement<any>
  //       }
  //       codes={permissionsDocumentsReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents-add"
  //   path="documents/add"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         (<AddDocument parentPath={parentPath} />) as React.ReactElement<any>
  //       }
  //       codes={permissionsDocumentsFull}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents-view"
  //   path="documents/view/:id"
  //   element={
  //     <ProtectedRoute
  //       element={<DocumentView />}
  //       codes={permissionsDocumentsReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents-edit"
  //   path="documents/edit/:id"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         (<AddDocument parentPath={parentPath} />) as React.ReactElement<any>
  //       }
  //       codes={permissionsDocumentsFull}
  //     />
  //   }
  // />,
  // <Route
  //   key="companies-locations"
  //   path="companies/:customerId/locations"
  //   element={
  //     <ProtectedRoute
  //       element={(<CompanyLocations />) as React.ReactElement<any>}
  //       codes={permissionsCompaniesReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="companies-locations"
  //   path={`${routesData.locations}`}
  //   element={
  //     <ProtectedRoute
  //       element={<CompanyLocations />}
  //       codes={permissionsLocationsReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="companies-locations-meters"
  //   path={`${routesData.locationsMeters}`}
  //   element={
  //     <ProtectedRoute
  //       element={<MeterList />}
  //       codes={permissionsLocationsReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="companies-locations-meters-data"
  //   path={`${routesData.locationsMetersData}`}
  //   element={
  //     <ProtectedRoute
  //       element={<MeterData />}
  //       codes={permissionsLocationsReadonly}
  //     />
  //   }
  // />,
  <Route path="company-users/:userId">{userRoutes(parentPath)}</Route>,
  <Route path="companies/:customerId">
    {companyRoutes(parentPath, { showLocations: true })}
  </Route>,
  <Route path="tenants/:tenantId">
    {tenantRoutes(parentPath, { showLocations: true, showCompanies: true })}
  </Route>,
  <Route path="locations">{locationRoutes(parentPath)}</Route>,
];
